var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sportFootballMatchActionActive"},[_c('el-switch',{attrs:{"inactive-text":"Off","active-text":"On","active-color":"#13ce66"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }